export default __webpack_public_path__ + "static/media/noprofilepic.8973ad91.png";